import React from 'react';

import './index.css';

import ReactDOM from 'react-dom/client';

import App from './App';
import EnvBadge from './EnvBadge';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <EnvBadge />
  </>,
);
